import { useState } from "react";
import { Link } from "react-router-dom";
import { MessageCircle, X, Phone, Mail, Clock, ChevronRight } from "lucide-react";

const WHATSAPP_NUMBER = "918796027362";
const QUICK_LINKS = [
  { label: "Which product is right for my car?", to: "/shop" },
  { label: "Bulk / B2B & partnership enquiry", to: "/partner" },
  { label: "Track my order", to: "/account?tab=orders" },
  { label: "Detailing guides & tips", to: "/guides" },
];

export const SupportWidget = () => {
  const [open, setOpen] = useState(false);
  const waLink = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
    "Hi AutoCareX, I have a pre-purchase question about "
  )}`;

  return (
    <>
      {open && (
        <div
          data-testid="support-panel"
          className="fixed bottom-24 right-4 z-[200] w-[min(360px,calc(100vw-2rem))] overflow-hidden rounded-[18px] border border-[color:var(--acx-border)] bg-[var(--acx-card)] shadow-2xl"
        >
          <div className="relative bg-[linear-gradient(135deg,#E11B22_0%,#9a1318_100%)] px-5 py-4">
            <p className="text-[15px] font-bold text-white">AutoCareX Support</p>
            <p className="mt-0.5 text-[12px] text-white/85">Real answers before you buy — we usually reply in minutes.</p>
          </div>

          <div className="max-h-[60vh] overflow-y-auto p-4">
            <a
              href={waLink}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="support-whatsapp"
              className="flex items-center justify-center gap-2 rounded-[12px] bg-[#25D366] px-4 py-3 text-[14px] font-semibold text-[#06351b] transition-opacity hover:opacity-90"
            >
              <MessageCircle size={18} /> Chat with us on WhatsApp
            </a>

            <p className="mb-2 mt-5 text-[11px] uppercase tracking-[0.16em] text-white/45">Popular questions</p>
            <div className="space-y-1">
              {QUICK_LINKS.map((q) => (
                <Link
                  key={q.to + q.label}
                  to={q.to}
                  onClick={() => setOpen(false)}
                  className="flex items-center justify-between gap-2 rounded-[10px] px-3 py-2.5 text-[13.5px] text-white/80 transition-colors hover:bg-white/5 hover:text-white"
                >
                  {q.label} <ChevronRight size={15} className="shrink-0 text-white/35" />
                </Link>
              ))}
            </div>

            <div className="mt-5 space-y-2 border-t border-[color:var(--acx-border)] pt-4 text-[13px] text-white/65">
              <a href="tel:+918796027362" className="flex items-center gap-2 transition-colors hover:text-white"><Phone size={14} /> +91-87960 27362</a>
              <a href="mailto:help@autocarex.in" className="flex items-center gap-2 transition-colors hover:text-white"><Mail size={14} /> help@autocarex.in</a>
              <p className="flex items-center gap-2 text-white/45"><Clock size={14} /> Mon–Sat, 10:00 AM – 7:00 PM IST</p>
            </div>
          </div>
        </div>
      )}

      <button
        onClick={() => setOpen((o) => !o)}
        data-testid="support-fab"
        aria-label={open ? "Close support" : "Open support chat"}
        className="fixed bottom-5 right-4 z-[200] inline-flex h-14 w-14 items-center justify-center rounded-full bg-[#E11B22] text-white shadow-xl transition-transform duration-200 hover:scale-105 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/50"
      >
        {open ? <X size={24} /> : <MessageCircle size={24} />}
      </button>
    </>
  );
};

export default SupportWidget;
